export const getCurrentDate = () => {
  return new Date().toISOString().split('T')[0];
};

export const createArticleSchema = (
  headline: string,
  description: string,
  url: string,
  datePublished?: string,
  dateModified?: string
) => {
  const today = getCurrentDate();
  
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": headline,
    "description": description,
    "author": {
      "@type": "Organization",
      "name": "Dstino",
      "url": window.location.origin
    },
    "publisher": {
      "@type": "Organization",
      "name": "Dstino",
      "url": window.location.origin
    },
    "datePublished": datePublished || today,
    "dateModified": dateModified || today,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "inLanguage": "es-ES"
  };
};

export const createWebApplicationSchema = (
  name: string,
  description: string,
  category: string
) => {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": name,
    "description": description,
    "applicationCategory": category,
    "operatingSystem": "Any",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "inLanguage": "es-ES"
  };
};

export const createFAQSchema = (faqs: Array<{ question: string; answer: string }>) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};

export const createOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Dstino",
    "url": window.location.origin,
    "logo": `${window.location.origin}/favicon.ico`,
    "sameAs": [
      "https://open.spotify.com/show/7makyw1CJREHr2CwcTMeKc"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "dstino@dkensgroup.com",
      "contactType": "customer service"
    }
  };
};
